import { useState, useEffect, useRef, RefObject } from 'react';

export function useElementWidth<T extends HTMLElement>(): [RefObject<T>, number | undefined] {
    const ref = useRef<T>(null);
    const [width, setWidth] = useState<number>();

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        setWidth(element.getBoundingClientRect().width);

        const observer = new ResizeObserver(([entry]) => {
            setWidth(entry.contentRect.width);
        });

        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return [ref, width];
}
